import { repeatCustomer } from "../AttributionAnalysis/repeatCustomer";
import { getActiveBranchIds1 } from "../multipleBranch/getActiveBranchId";

export function getAttribtionDataByBranchArray(branches) {
  // branches is array of active branches.
  let data = JSON.parse(sessionStorage.getItem("attribution"));

  let activeBranches = branches;

  let output = data.filter((d) => {
    if (activeBranches.indexOf(d.branchId) > -1) {
      return true;
    }
  });

  return output;
}

// we have to re calculate attribution data as per given dates.- filter feedback data.

export function generateAttributionData(data) {
  console.log(data);
  let output = repeatCustomer(data, "report");
  //console.log(output);

  return output;
}
